import {Action} from '@ngrx/store';
import {RsvpQuestion} from '../../../models/rsvp-question';


export class GetRsvpQuestionsSuccessAction implements Action {
  public static readonly type = 'GetRsvpQuestionsSuccessAction';

  constructor(public rsvpQuestions: RsvpQuestion[]) {
  }

  public type = GetRsvpQuestionsSuccessAction.type;
}
